import React from 'react';
import DefaultForm from './default';
import USForm from './US';
import GBForm from './GB';
import IEForm from './IE';
import HKForm from './HK';
import MOForm from './MO';
import TWForm from './TW';
import JPForm from './JP';
import KRForm from './KR';
import AUForm from './AU';
import BEForm from './BE';
import MXForm from './MX';
import AEForm from './AE';
import CNForm from './CN';
import FIForm from './FI';

const formUS = (props) => {
    return (
        <USForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formGB = (props) => {
    return (
        <GBForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const FormDefault = (props) => {
    return (
        <DefaultForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formIE = (props) => {
    return (
        <IEForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formHK = (props) => {
    return (
        <HKForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formMO = (props) => {
    return (
        <MOForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formTW = (props) => {
    return (
        <TWForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formJP = (props) => {
    return (
        <JPForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formKR = (props) => {
    return (
        <KRForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            provinceList={props.provinceList}
            cityList={props.cityList}
            showECheckbox={props.showECheckbox}
            values={props.values}
            updateValue={props.updateValue} />
    )
}

const formAU = (props) => {
    return (
        <AUForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formBE = (props) => {
    return (
        <BEForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formMX = (props) => {
    return (
        <MXForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formAE = (props) => {
    return (
        <AEForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formCN = (props) => {
    return (
        <CNForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            provinceList={props.provinceList}
            cityList={props.cityList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

const formFI = (props) => {
    return (
        <FIForm
            handleSubmit={props.handleSubmit}
            handleChange={props.handleChange}
            form={props.form}
            countryList={props.countryList}
            showECheckbox={props.showECheckbox}
            values={props.values} />
    )
}

export default function Forms() {
    return {
        formUS,
        formGB,
        formIE,
        formHK,
        formMO,
        formTW,
        formJP,
        formKR,
        formAU,
        formBE,
        formMX,
        formAE,
        formCN,
        formFI,
        FormDefault
    }
}
